import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../../services/category.service';
import { ActivatedRoute, Router } from '@angular/router';
import {environment} from "../../../environments/environment";
import {ProductDto} from "../../entities/product/ProductDto";
import {ProductCategoryDto} from "../../entities/product/ProductCategoryDto";
import {EntityListDto} from "../../entities/common/EntityListDto";

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  imageURL: string = environment.baseIconUrl;
  tests: ProductDto[];
  page: number = 1;
  categoryName: string = '';
  testsCount: number;
  idCategory: string;

  constructor(private readonly categoryService: CategoryService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  mainPageNavigate(): void {
    this.router.navigate(['/']);
  }

  allTestsNavigate(): void {
    this.router.navigate(['/all']);
  }

  testNavigate(test: ProductDto): void {
    this.router.navigateByUrl(`product/${test.slug}`);
  }

  onPageChange(currentPage: number): void {
    const limit = 10;
    const offset = (currentPage - 1) * limit;

    this.categoryService.getCategoryTests(this.idCategory, limit, offset)
      .subscribe((tests: EntityListDto<ProductDto>) => {
        this.tests = tests.entities;
        this.testsCount = tests.totalCount;
      });

    scroll(0, 0);
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.idCategory = params.get('id');

      this.categoryService.getCategoryById(this.idCategory) .subscribe((categoryResult: ProductCategoryDto) => {
        this.categoryName = categoryResult.name;
      });

      this.categoryService.getCategoryTests(this.idCategory, 10, 0).subscribe((tests: EntityListDto<ProductDto>) => {
        this.tests = tests.entities;
        this.testsCount = tests.totalCount;
      });
    });
  }

}
